import { useState, useEffect } from "react";
import TeamSlider from "../components/TeamSlider";
import PatientMilestones from "../components/PatientMilestones";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";


function About() {

    // ✅ WHY CHOOSE US – SLIDER STATE (YAHAN SAHI JAGAH)
    const whyChooseSlides = [
        {
            text: "Experienced doctors and skilled medical staff",
            image: "/images/About/why-choose/1.jpg",
        },
        {
            text: "Modern infrastructure and advanced medical technology",
            image: "/images/About/why-choose/2.jpg",
        },
        {
            text: "Transparent treatment plans and ethical practices",
            image: "/images/About/why-choose/3.jpg",
        },
        {
            text: "Affordable healthcare with compassionate care",
            image: "/images/About/why-choose/4.jpg",
        },
        {
            text: "24×7 emergency and critical care support",
            image: "/images/About/why-choose/5.jpg",
        },
    ];

    const [currentWhy, setCurrentWhy] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentWhy((prev) => (prev + 1) % whyChooseSlides.length);
        }, 3000);

        return () => clearInterval(timer);
    }, []);
    const innerBox =
        "bg-gradient-to-br from-[#f1f6ff]/90 to-[#fdf2ff]/90 backdrop-blur-md border-2 border-black/30 rounded-2xl shadow-xl";

    return (
        <section className="w-full py-10 px-4 md:px-5"
            style={{
                background:
                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
            }}
        >
            <div className="max-w-5xl mx-auto">

                {/* ================= ABOUT HEADING SECTION ================= */}
                <section className="py-12 md:py-16">
                    <div className="max-w-7xl mx-auto px-4">

                        {/* 🔵 OUTER BACKGROUND (HOME STYLE) */}
                        <div
                            className="rounded-3xl p-6 md:p-10 shadow-2xl"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                            }}
                        >
                            {/* ⚪ INNER CONTENT BOX */}
                            <div className="bg-gradient-to-br from-[#eef4ff] to-[#f7faff]
                            border border-[#c7d7ee]
                            rounded-2xl
                            px-6 py-8 md:px-12 md:py-12
                            shadow-xl">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

                                    {/* LEFT IMAGE */}
                                    <div className="w-full h-64 md:h-80 rounded-xl overflow-hidden shadow-md">
                                        <img
                                            src="/images/About/Main-1.jpg"
                                            alt="Gavli Hospital Kurawar"
                                            className="w-full h-full object-cover"
                                        />
                                    </div>

                                    {/* RIGHT TEXT */}
                                    <div className="text-center md:text-left">
                                        <h2 className="text-2xl md:text-4xl font-bold text-[#0b3c78] mb-4">
                                            Gavli Hospital Kurawar
                                        </h2>

                                        <p className="text-[#334155] leading-relaxed text-base md:text-lg max-w-xl mx-auto md:mx-0">
                                            Gavli Hospital Kurawar is a trusted multi-specialty hospital committed to
                                            delivering high-quality, affordable, and patient-centric healthcare
                                            services with compassion, integrity, and advanced medical infrastructure.
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {/* ================= FOUNDERS & BOARD ================= */}
                <div className="mb-14">
                    {/* 🔵 OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-4">
                            Founders & Board of Directors
                        </h3>

                        <p className="text-white/90 text-center max-w-3xl mx-auto mb-10">
                            Gavli Hospital Kurawar is guided by experienced healthcare leaders
                            committed to ethical practices, quality treatment, and patient-focused
                            medical services.
                        </p>

                        {/* 🔹 INNER GRADIENT BOX */}
                        <div
                            className="rounded-2xl p-6 md:p-8 shadow-xl"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                            }}
                        >
                            {/* CARDS GRID */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                                {/* ===== FOUNDER CARD ===== */}
                                <div className="rounded-2xl shadow-2xl overflow-hidden transition hover:-translate-y-1">
                                    <div className="h-[260px] w-full">
                                        <img
                                            src="/images/About/doctor-1.jpg"
                                            alt="Dr. Naresh Kumar Gavli"
                                            className="w-full h-full object-cover"
                                        />
                                    </div>

                                    <div className="p-6 text-center bg-white/95">
                                        <h4 className="font-bold text-xl text-[#0b3c78]">
                                            Dr. Naresh Kumar Gavli
                                        </h4>
                                        <p className="text-blue-600 text-sm mb-3">
                                            Founder & Medical Director
                                        </p>
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            Leads the hospital with a strong focus on clinical excellence,
                                            ethical medical practices, and community healthcare.
                                        </p>
                                    </div>
                                </div>

                                {/* ===== DIRECTOR CARD ===== */}
                                <div className="rounded-2xl shadow-2xl overflow-hidden transition hover:-translate-y-1">
                                    <div className="h-[260px] w-full">
                                        <img
                                            src="/images/About/doctor-2.jpg"
                                            alt="Dr. Tarun Gavli"
                                            className="w-full h-full object-cover"
                                        />
                                    </div>

                                    <div className="p-6 text-center bg-white/95">
                                        <h4 className="font-bold text-xl text-[#0b3c78]">
                                            Dr. Tarun Gavli
                                        </h4>
                                        <p className="text-blue-600 text-sm mb-3">
                                            Director – Administration
                                        </p>
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            Responsible for hospital operations, service quality, patient
                                            safety, and overall administrative management.
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                {/* ================= DIRECTOR MESSAGE ================= */}
                <div className="mb-14">
                    <div
                        className="
      bg-[#f4f6f8]
      border border-[#d6dbe1]
      rounded-xl
      shadow-sm
      px-6 py-8 md:px-10
      relative
    "
                    >
                        {/* LEFT ACCENT BAR */}
                        <span className="absolute left-0 top-0 h-full w-1 bg-[#0b3c78] rounded-l-xl"></span>

                        <div className="flex flex-col md:flex-row items-center gap-8">

                            {/* IMAGE */}
                            <div className="w-full md:w-1/2">
                                <img
                                    src="/images/About/tarun.jpg"
                                    alt="Dr. Tarun Gavli - Director, Gavli Hospital"
                                    className="w-full h-[240px] md:h-[300px] object-cover rounded-lg shadow-sm"
                                />
                            </div>

                            {/* TEXT */}
                            <div className="w-full md:w-1/2">
                                <h3 className="text-2xl font-bold text-[#0b3c78] mb-4">
                                    Director’s Message
                                </h3>

                                <p className="text-[#374151] leading-relaxed text-base md:text-lg mb-3">
                                    At Gavli Hospital Kurawar, our commitment is to provide reliable,
                                    ethical, and patient-centered healthcare services. We continuously
                                    focus on quality treatment, modern medical practices, and
                                    compassionate care to serve our community.
                                </p>

                                {/* DIRECTOR NAME */}
                                <p className="font-semibold text-[#0b3c78]">
                                    — Dr. Tarun Gavli
                                </p>
                                <p className="text-sm text-gray-600">
                                    Director, Gavli Hospital Kurawar
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                {/* ================= IN THE NEWS ================= */}
                <div className="mb-14">
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* INNER BOX */}
                        <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

                                {/* NEWS IMAGE */}
                                <div className="rounded-xl overflow-hidden shadow-md">
                                    <img
                                        src="/images/Home/achievements/news.jpg"
                                        alt="Raja Express News - Gavli Hospital Kurawar"
                                        className="w-full h-full object-cover"
                                    />
                                </div>

                                {/* NEWS TEXT */}
                                <div>
                                    <h4 className="text-xl md:text-2xl font-bold text-[#0b3c78] mb-4">
                                        Gavli Hospital Kurawar Recognized by NABH
                                    </h4>

                                    <p className="text-gray-700 leading-relaxed mb-4">
                                        Gavli Hospital Kurawar has been recognized as the first
                                        NABH-accredited hospital in the Kurawar region of Rajgarh
                                        district. This achievement highlights the hospital’s
                                        commitment to maintaining national healthcare standards,
                                        patient safety, and quality medical services.
                                    </p>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* ================= WHY CHOOSE US ================= */}
                <div className="mb-14">
                    {/* 🔵 OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* ⚪ INNER SOFT GRADIENT BOX */}
                        <div
                            className="rounded-2xl p-6 md:p-10 shadow-xl"
                            style={{
                                background:
                                    "linear-gradient(135deg, #f1f6ff 0%, #fdf2ff 50%, #eef4ff 100%)",
                            }}
                        >
                            {/* HEADING */}
                            <h3 className="text-2xl md:text-3xl font-bold text-center text-[#0b3c78] mb-8">
                                Why Choose Gavli Hospital Kurawar
                            </h3>

                            {/* CONTENT */}
                            <div className="flex flex-col md:flex-row items-center gap-8">

                                {/* LEFT IMAGE */}
                                <div className="w-full md:w-1/2">
                                    <img
                                        src={whyChooseSlides[currentWhy].image}
                                        alt="Why Choose Gavli Hospital"
                                        className="w-full h-[240px] md:h-[300px] object-cover rounded-xl shadow-lg"
                                    />
                                </div>

                                {/* RIGHT TEXT */}
                                <div className="w-full md:w-1/2">
                                    <p className="text-lg md:text-xl font-medium text-gray-800 leading-relaxed">
                                        {whyChooseSlides[currentWhy].text}
                                    </p>

                                    {/* DOT INDICATORS */}
                                    <div className="flex gap-3 mt-6">
                                        {whyChooseSlides.map((_, index) => (
                                            <span
                                                key={index}
                                                onClick={() => setCurrentWhy(index)}
                                                className={`w-3.5 h-3.5 rounded-full cursor-pointer transition
                  ${index === currentWhy
                                                        ? "bg-[#0b3c78]"
                                                        : "bg-gray-300 hover:bg-gray-400"
                                                    }`}
                                            />
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                {/* ================= MISSION & VISION ================= */}
                <div className="mb-14">
                    {/* 🔵 OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10">
                            Mission & Vision
                        </h3>

                        {/* CONTENT */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                            {/* MISSION CARD */}
                            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl">
                                <h4 className="text-xl md:text-2xl font-bold mb-4 text-[#0b3c78]">
                                    Our Mission
                                </h4>

                                <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                                    To deliver compassionate, ethical, and patient-focused healthcare
                                    using modern medical technology, while ensuring safety, quality,
                                    and affordability for every patient.
                                </p>
                            </div>

                            {/* VISION CARD */}
                            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl">
                                <h4 className="text-xl md:text-2xl font-bold mb-4 text-[#0b3c78]">
                                    Our Vision
                                </h4>

                                <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                                    To become a trusted healthcare leader by providing world-class
                                    medical services, improving patient outcomes, and building
                                    long-term trust within the community.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>


                {/* ================= OUR TEAM ================= */}
                <div className="mb-14">
                    {/* 🔵 OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10">
                            Our Team
                        </h3>

                        {/* 🔹 INNER GRADIENT BOX (SAME AS OUTER) */}
                        <div
                            className="rounded-2xl p-6 md:p-10 shadow-xl overflow-hidden"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                            }}
                        >
                            <TeamSlider />
                        </div>
                    </div>
                </div>



                {/* ================= CORE VALUES ================= */}
                <div className="mb-14">
                    {/* 🔵 ONLY ONE OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10">
                            Our Core Values
                        </h3>

                        {/* GRID */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">

                            {[
                                {
                                    title: "Patient Safety",
                                    desc: "Safety and dignity come first in every treatment we provide.",
                                    img: "/images/About/Core-value/1.jpg",
                                },
                                {
                                    title: "Ethical Care",
                                    desc: "Honest, transparent, and ethical medical practices always.",
                                    img: "/images/About/Core-value/2.jpg",
                                },
                                {
                                    title: "Teamwork",
                                    desc: "Strong teamwork ensures better care and faster recovery.",
                                    img: "/images/About/Core-value/3.jpg",
                                },
                                {
                                    title: "Innovation",
                                    desc: "Continuous learning and modern care for better outcomes.",
                                    img: "/images/About/Core-value/4.jpg",
                                },
                            ].map((item, i) => (
                                <div
                                    key={i}
                                    className="
            bg-white
            rounded-2xl
            shadow-xl
            overflow-hidden
            transition-transform
            hover:-translate-y-1
            hover:shadow-2xl
          "
                                >
                                    {/* IMAGE */}
                                    <div className="h-48">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>

                                    {/* TEXT */}
                                    <div className="p-5 text-center">
                                        <h4 className="font-bold text-lg text-[#0b3c78] mb-2">
                                            {item.title}
                                        </h4>
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>


                {/* ================= AWARDS & CERTIFICATIONS ================= */}
                <div className="mb-14">
                    {/* 🔵 OUTER GRADIENT BOX */}
                    <div
                        className="rounded-3xl p-6 md:p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10">
                            Awards & Certifications
                        </h3>

                        {/* 🔹 INNER GRADIENT BOX (SAME AS OUTER) */}
                        <div
                            className="rounded-2xl p-6 md:p-8 shadow-xl"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)",
                            }}
                        >
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">

                                {[
                                    ["Quality Care", "text-blue-600"],
                                    ["Certified Provider", "text-green-600"],
                                    ["Medical Compliance", "text-purple-600"],
                                    ["Regular Audits", "text-red-600"],
                                ].map(([title, color], i) => (
                                    <div
                                        key={i}
                                        className="bg-white rounded-xl p-6 text-center shadow-xl transition hover:-translate-y-1 hover:shadow-2xl"
                                    >
                                        <h4 className={`font-bold mb-2 ${color}`}>
                                            {title}
                                        </h4>
                                        <p className="text-sm text-gray-700">
                                            Recognized for maintaining high standards of healthcare quality.
                                        </p>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>


                {/* ================= PatientMilestones ================= */}
                <PatientMilestones />

            </div>
        </section >
    );
}

export default About;
